import moment from 'moment';

export const getQuote = state => state.quote;
export const getQuoteUser = state => state.quote.user ? state.quote.user.data : null;
export const getVehicles = state => state.vehicles;
export const getUserToken = state => state.userToken;
export const getCharges = state => state.vehicles[0].charges ? state.vehicles[0].charges : [];
export const getChargeTotals = state => state.quote.selected_vehicle ? state.quote.selected_vehicle.data.vehicle.data.charge_totals : {};
export const getCurrencies = state => state.currencies;
export const getVehicleInsuranceOptions = state => state.vehicleInsuranceOptions;
export const getExtras = state => state.extras;
export const getTotals = state => state.quote.totals ? state.quote.totals.data : [];
export const getCustomer = state => state.customer;
export const getQuoteCustomer = state => state.quote.customer;
export const getLocale = state => state.quote.locale;
export const getSelectedVehicle = state => state.quote.selected_vehicle ? state.quote.selected_vehicle.data.vehicle.data : {};
export const getSelectedVehicleData = state => state.quote.selected_vehicle ? state.quote.selected_vehicle.data : {};
export const getSelectedVehicleInsuranceOptions = state => state.quote.selected_vehicle && state.quote.selected_vehicle.data.selected_insurance_options
  ? state.quote.selected_vehicle.data.selected_insurance_options.data
  : [];
export const getProducts = state => state.quote.selected_vehicle && state.quote.selected_vehicle.data.vehicle.data.products
    ? state.quote.selected_vehicle.data.vehicle.data.products.data
    : [];
export const getSelectedVehicleProduct = state => state.quote.selected_vehicle && state.quote.selected_vehicle.data.product ? state.quote.selected_vehicle.data.product.data : {};
export const getSelectedExtras = state => state.quote.selected_extras ? state.quote.selected_extras.data : [];
export const getPickupLocation = state => state.quote.pickup_location.data;
export const getDropoffLocation = state => state.quote.dropoff_location.data;
export const getPickupDate = state => state.search.pickupDate;
export const getPickupTime = state => state.search.pickupTime;
export const getDropoffDate = state => state.search.dropoffDate;
export const getDropoffTime = state => state.search.dropoffTime;
export const getPromoCode= state => state.search.promoCode;
export const quoteHireDuration = (state) => {
    // Get the hire duration from FMX / Database
    if (state.quote.hire_duration_in_days) {
        return state.quote.hire_duration_in_days
    }

    // If didn't get duration from FMX, calculate the standard duration
    let duration = moment(state.quote.utc_dropoff_datetime).diff(moment(state.quote.utc_pickup_datetime), 'hours');
    return Math.ceil(duration / 24) || 1;
};
export const quotePaymentType = state => state.quote.payment_type;
export const getCreateDirect = state => window.greenmotion ? window.greenmotion.createDirect : false;
export const selectedCurrency = state => {
  const selectedCurrency = state.currencies.filter(currency => {
    return currency.code == state.currency.code;
  });

  return selectedCurrency.length ? selectedCurrency[0] : state.currency;
};
export const getSavedCards = state => {
  if (!state.quote) {
      return [];
  } else if (!state.quote.user) {
      return [];
  } else if (!state.quote.user.data.cards) {
      return [];
  } else if (!state.quote.user.data.cards.data) {
      return [];
  } else {
      return state.quote.user.data.cards.data.map(item => {
          return {
              id: item.id,
              brand: item.brand,
              number: "**** **** **** " + item.last4,
              expiry: item.exp_month + "/" + item.exp_year
          };
      });
  }
}

export const getHasUpgradedVehicle = state => state.hasUpgradedVehicle;
export const getSelectedVehicleType = state => state.selectedVehicleType;
export const getBooking = state => state.booking;
export const getOriginalQuoteDonation = state => state.booking.original_donation_total;
export const getModification = state => state.modification.changes;
export const getNewQuote = state => state.modification.new_quote;
export const getBookingUpdateStatus = state => state.bookingUpdating;
export const getLoadingStatus = state => state.loading;
export const getTab = state => state.tab;
